import { createBrowserHistory } from "history";

const history = createBrowserHistory().location.pathname;

export default history;